import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { externalMatchRefreshPaths, getNotFoundPagePath, getFullPathOrHome } from 'utils/paths';
import { getNA, get as getExternalAccessConfig, updateActivityLog } from 'api/externalAccess';
import { defineType, setLoggedIn, setAccessKey } from 'utils/externalAccess';
import actions from 'store/actions';
import searchParams from 'constants/searchParams';
import paths from 'constants/paths';

export function useExternalAccessFetching() {
  const history = useHistory();
  const dispatch = useDispatch();
  const na = useSelector((state) => state.na);
  const [loading, setLoading] = useState(false);

  const getExternalNaClientConfiguration = async (id, accessKey, isPreview) => {
    setLoading(true);
    try {
      const needsAssessment = await getNA(id, accessKey);
      dispatch(actions.na.setNA(needsAssessment));
      const externalAccessConfig = await getExternalAccessConfig(accessKey);
      dispatch(actions.externalAccess.setExternalAccessConfig(externalAccessConfig));
      if (!externalAccessConfig.readModeEnabled && !externalAccessConfig.interactiveModeEnabled) {
        history.push(getFullPathOrHome(paths.externalAccessDenied));
        setLoggedIn(false);
      }
      if (isPreview !== 'true') {
        await updateActivityLog({
          accessKey: accessKey,
          na: needsAssessment,
          type: defineType(externalAccessConfig.brokerNaId, needsAssessment.id),
          updateLastUpdate: false,
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setLoggedIn(false);
      setAccessKey('');
      switch (error.response.status) {
        case 404:
        case 403:
          history.push(getFullPathOrHome(paths.externalAccessDenied));
          break;
        default:
          const loginPage = getFullPathOrHome(
            `${paths.externalAccessLogin}?${searchParams.accessKey}=${accessKey}`,
          );
          history.push(loginPage);
          break;
      }
    }
  };

  const fetchExternalAccess = (pathname, accessKey, isPreview) => {
    if (loading || pathname === getNotFoundPagePath()) return;

    const match = externalMatchRefreshPaths(pathname);
    const newId = match && Number(match[3]);
    if (!newId || newId === na.id) return;

    getExternalNaClientConfiguration(newId, accessKey, isPreview);
  };

  return [loading, { fetchExternalAccess }];
}
